import React, { useState } from 'react';
import { Eye, EyeOff, RefreshCw } from 'lucide-react';
import { generatePassword } from './vaultItemData';

/** modal-input password field with reveal eye + optional generator button. */
export function PasswordInput({ value, onChange, placeholder, withGenerator, generateLabel }) {
  const [reveal, setReveal] = useState(false);
  return (
    <div className="vault-pw-row">
      <div className="pw-input-wrap">
        <input
          type={reveal ? 'text' : 'password'}
          className="modal-input"
          style={{ width: '100%' }}
          placeholder={placeholder || ''}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          className="pw-eye-btn"
          tabIndex={-1}
          onClick={() => setReveal((r) => !r)}
          aria-label="Toggle visibility"
        >
          {reveal ? <EyeOff size={15} /> : <Eye size={15} />}
        </button>
      </div>
      {withGenerator && (
        <button
          type="button"
          className="vault-gen-btn"
          title={generateLabel}
          aria-label={generateLabel}
          onClick={() => onChange(generatePassword())}
        >
          <RefreshCw size={14} />
        </button>
      )}
    </div>
  );
}

export function FieldLabel({ children, required }) {
  return (
    <label className="modal-logo-label" style={{ display: 'block', marginBottom: '0.375rem' }}>
      {children}
      {required ? ' *' : ''}
    </label>
  );
}
